"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        /**
         * Localization strings
         * @readonly
         */
        Globalize.addCultureInfo("en", {
            messages: {
                ContextMenu_AddColumns: "Insert columns...",
                ContextMenu_ControlName: "Control Name: {0}",
                ContextMenu_ExportAllRows: "Export all rows",
                ContextMenu_ExportMarkedRows: "Export marked rows",
                ContextMenu_FormName: "Form Name: {0}",
                ContextMenu_HideColumn: "Hide this column",
                ContextMenu_Personalization: "Personalize",
                ContextMenu_PersonalizationControl: "Personalize: {0}",
                ContextMenu_Personalize: "Form information",
                ContextMenu_UpdateUrl: "Update URL",
                ContextMenu_ViewDetails: "View details",
            }
        });
        /**
         * Framework class to display additional context menu information
         * @internal
         * @param data the backing data - built in displayContextMenu.
         * @param target the element.
         */
        var ContextMenu = /** @class */ (function (_super) {
            __extends(ContextMenu, _super);
            function ContextMenu(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                /**
                 * close the context menu and unbind the closeContextMenus handlers
                 */
                _this.closeContextMenu = function () {
                    if (_this.ContextMenuShow) {
                        _this.ContextMenuShow(false);
                    }
                    $(document.body).off("closeContextMenus." + _this.ContextMenuId, _this.closeContextMenu);
                };
                _this.isHovered = $dyn.observable(false);
                _this.ContextMenuId = $dyn.contextMenu.nextMenuId();
                if (data && data.DataSource) {
                    _this.List = data.DataSource.contextMenuOptions;
                    _this.ContextMenuShow = data.DataSource.contextMenuShow;
                    _this.ParentSubMenuButton = data.DataSource.parentSubMenuButton;
                }
                $(document.body).on("closeContextMenus." + _this.ContextMenuId, _this.closeContextMenu);
                return _this;
            }
            /**
             * checks if the context menu is not hovered and does not have any open submenus
             * @returns True if the context menu is not hovered and does not have any open submenus.
             */
            ContextMenu.prototype.shouldClose = function () {
                return !this.isHovered() && !this.hasOpenSubmenu();
            };
            /**
             * Checks the context menu for open submenus
             * @returns True if the context menu has any open submenus.
             */
            ContextMenu.prototype.hasOpenSubmenu = function () {
                var e_1, _a;
                if (this.subMenuButtons && this.subMenuButtons.length > 0) {
                    try {
                        for (var _b = __values(this.subMenuButtons), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var subMenuButton = _c.value;
                            if (subMenuButton.isSubContextMenuOpen()) {
                                return true;
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
                return false;
            };
            /**
             * closes the context menu if it should
             */
            ContextMenu.prototype.tryClose = function () {
                // if this is the root menu they need to click or hit escape to close it
                if (!this.ParentSubMenuButton) {
                    return;
                }
                // if not its a sub menu and if it is not hovered or has an open sub menu we need to close it
                if (this.shouldClose()) {
                    this.ParentSubMenuButton.CloseContextMenu();
                }
            };
            /**
             * After the root context menu is rendered, add the submenu buttons to the list to monitor
             */
            ContextMenu.prototype.postRender = function () {
                var _this = this;
                this.subMenuButtons = [];
                if (this.List.length > 0) {
                    var contextMenus = $(this.element).find(".contextMenuButton");
                    contextMenus.each(function (index, element) {
                        // if the isSubContextMenuOpen function exists this is a sub menu button
                        var contextMenuItem = $dyn.context(element);
                        if (contextMenuItem.isSubContextMenuOpen) {
                            _this.subMenuButtons.push(contextMenuItem);
                        }
                    });
                }
            };
            return ContextMenu;
        }($dyn.ui.Container));
        controls.ContextMenu = ContextMenu;
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=ContextMenu.js.map
